import { SIM } from '../../shared/config';
export function usd(n: number): string {
  if (!Number.isFinite(n)) return '-';
  const a = Math.abs(n), s = n < 0 ? '-' : '';
  if (a >= 1e9) return `${s}$${(a / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `${s}$${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `${s}$${(a / 1e3).toFixed(a >= 1e4 ? 1 : 2)}K`;
  return `${s}$${a.toFixed(a >= 10 ? 0 : 2)}`;
}
export function sol(lamportsOrSol: number, isLamports = true, dp = 3): string {
  const v = isLamports ? lamportsOrSol / SIM.LAMPORTS : lamportsOrSol;
  if (!Number.isFinite(v)) return '-';
  const a = Math.abs(v);
  return a >= 1000 ? v.toLocaleString(undefined, { maximumFractionDigits: 1 }) : v.toFixed(a >= 100 ? 2 : dp);
}
export function signed(s: string, n: number) { return n > 0 ? '+' + s : s; }
export function age(ms: number): string {
  if (ms < 0) ms = 0;
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`; if (s < 3600) return `${Math.floor(s / 60)}m`; return `${Math.floor(s / 3600)}h`;
}
export function ms(n: number | null | undefined): string { return n == null ? '-' : n >= 10000 ? `${(n / 1000).toFixed(1)}s` : `${Math.round(n)}ms`; }
export function short(a: string, n = 4) { return a.length <= n * 2 + 1 ? a : `${a.slice(0, n)}…${a.slice(-n)}`; }
export function compact(n: number) { const a = Math.abs(n); return a >= 1e6 ? (n / 1e6).toFixed(1) + 'M' : a >= 1e3 ? (n / 1e3).toFixed(1) + 'K' : String(Math.round(n)); }
export function pct(n: number, dp = 1) { return `${n.toFixed(dp)}%`; }
export function safeUrl(u: string | undefined): string | null {
  if (!u) return null;
  try { const x = new URL(u); return x.protocol === 'https:' || x.protocol === 'http:' ? x.toString() : null; } catch { return null; }
}
export async function copy(text: string): Promise<boolean> { try { await navigator.clipboard.writeText(text); return true; } catch { return false; } }
